export default "__VITE_ASSET__XKlA_2LU__"